import { render, staticRenderFns } from "./editResource_1_x.vue?vue&type=template&id=2628e1d2&"
import script from "./editResource_1_x.vue?vue&type=script&lang=js&"
export * from "./editResource_1_x.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports